import { render, staticRenderFns } from "./OurPeople.vue?vue&type=template&id=02de3dd8&scoped=true&"
import script from "./OurPeople.vue?vue&type=script&lang=js&"
export * from "./OurPeople.vue?vue&type=script&lang=js&"
import style0 from "./OurPeople.vue?vue&type=style&index=0&id=02de3dd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02de3dd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VApp,VChip})
